import React from 'react';

type Props = {
  title: string;
  message: string;
  buttonText: string;
  buttonOnClick: () => void;
};

const ConfirmationBox: React.FC<Props> = ({
  title,
  message,
  buttonText,
  buttonOnClick,
}) => {
  return (
    <div className="ConfirmationBox">
      <span className="ConfirmIcon"></span>
      <h2>{title}</h2>
      <p>{message}</p>
      <button onClick={buttonOnClick} className="Btn BtnOrange">
        {buttonText}
      </button>
    </div>
  );
};

export default ConfirmationBox;
